<template>
    <!-- Navigation -->
    <header class="orc-vert-limit-header">
      <div class="py-6">
        <div class="flex justify-between py-4">
            <!-- Logo -->
            <div class="flex">
                <a href="#" class="mob-menu pointer"  @click="drawer = true">
                    <i class="el-icon-s-unfold text-white mt-1 mr-2" style="font-size: 26px;"></i>
                </a>
                <router-link :to="{ path: 'home'}">
                    <div class="logo orc-strong top">
                        ORCA
                    </div>
                </router-link>
            </div>

            <!-- Nav -->
            <nav class="nav-main">
                <ul class="flex p-1">
                    <li class="ui-pill text-white" v-bind:class="{ selected: isPseudoBranch(branchId) }"><a href="#" @click="changeBranch(1)"><i class="el-icon-position text-white p-1 mr-1"></i>Home</a></li>
                    <span class="p-1 text-white"></span>
                    <li class="ui-pill text-white"><a href="#news"><i class="el-icon-news text-white p-1 mr-1"></i>Nieuws</a></li>
                    <span class="p-1 text-white"></span>
                    <li class="ui-pill text-white"><a href="#agenda"><i class="el-icon-date text-white p-1 mr-1"></i>Agenda</a></li>
                    <span class="p-1 pr-6 text-white"></span>
                    <el-popover
                            placement="bottom"
                            width="200"
                            trigger="hover">

                        <div class="px-4 pt-2">

                            <ul>
                                <li v-for="branch in nonPseudoBranches" v-bind:key="branch.id" class="py-1">
                                    <el-link type="primary" :underline="false" @click="changeBranch(branch.id)"> {{branch.label}}</el-link>
                                </li>
                            </ul>
                            <div class="flex justify-center my-4">
                                <el-button type="primary" @click="enroll()">Inschrijven<i class="ml-2 el-icon-plus"></i></el-button>
                            </div>
                        </div>

                        <li class="ui-pill text-white" v-bind:class="{ selected: !isPseudoBranch(branchId) }" slot="reference"><a href="#"><i class="el-icon-medal text-white p-1 mr-1"></i>{{ getCurrentBranchName(branchId) }}<i
                                class="el-icon-arrow-down ml-2"></i></a></li>
                    </el-popover>
                </ul>
            </nav>

            <!-- Main -->
            <div class="p-1 status-button">
                <div v-if="this.$store.getters.isLoggedIn">
                    <el-popover
                            placement="bottom"
                            width="200"
                            trigger="hover">

                        <div class="px-4 pt-4 pb-4">

                            <h3 class="text-2xl">{{ this.$store.getters.getFirstName }}</br>{{ this.$store.getters.getLastName }}</h3>

                            <span class="orc-label">{{ this.$store.getters.getEmail }}</span>

                            <ul class="my-6">
                                <li class="py-1">
                                    <el-link type="primary" :underline="false" @click="editProfile()"><i class="el-icon-user pr-2"></i>Profiel</el-link>
                                </li>
                                <li class="py-1" v-if="this.$store.getters.isStaff">
                                    <el-link type="primary" :underline="false" @click="showPerformancesDialog()"><i class="el-icon-timer pr-2"></i>Prestaties</el-link>
                                </li>
                                <li class="py-1" v-if="this.$store.getters.hasDashBoardAccess">
                                    <el-link type="primary" :underline="false"><i class="el-icon-full-screen pr-2"></i><router-link :to="{ path: 'dashboard/news'}">Dashboard</router-link></el-link>
                                </li>
                            </ul>

                            <div class="flex justify-center">
                                <el-button type="primary" @click="logout">Uitloggen<i class="el-icon-switch-button pl-2"></i></el-button>
                            </div>
                        </div>
                        <div class="ui-pill border text-main" slot="reference"><a href="#">{{ this.$store.getters.getFirstName }}<i class="el-icon-arrow-down ml-2"></i></a></div>
                    </el-popover>
                </div>
                <div v-else>
                    <div class="ui-pill border text-main" slot="reference"><router-link :to="{ path: 'login'}">Inloggen</router-link></div>
                </div>
            </div>
        </div>

        <performances-overview-dialog ref="viewDialog" :branch-options="branchOptions" :readOnly="true"></performances-overview-dialog>
        <enrollment-admin-dialog ref="profileDialog" :user-edit="true" :branch-options="branchOptions"></enrollment-admin-dialog>


        <el-drawer
                title="Menu"
                :visible.sync="drawer"
                size="100%">
            <div>

                <ul class="pl-4">
                    <li v-bind:class="{ selected: isPseudoBranch(branchId) }"><a href="#" @click="changeBranch(2)"><i class="el-icon-position p-1 mr-1"></i>Home</a></li>
                    <span class="p-1"></span>
                    <li><a href="#news"><i class="el-icon-news p-1 mr-1"></i>Nieuws</a></li>
                    <span class="p-1"></span>
                    <li><a href="#agenda"><i class="el-icon-date p-1 mr-1"></i>Agenda</a></li>
                    <span class="p-1 pr-6"></span>
                    <li v-bind:class="{ selected: !isPseudoBranch(branchId) }" slot="reference" @click="showDisc"><a href="#"><i class="el-icon-medal p-1 mr-1"></i>{{ getCurrentBranchName(branchId) }}<i
                            v-if="!showDisciplines" class="el-icon-arrow-down ml-2"></i><i
                            v-if="showDisciplines" class="el-icon-arrow-up ml-2"></i></a>
                        <div class="px-6 pt-2" v-if="showDisciplines">
                            <ul>
                                <li v-for="branch in nonPseudoBranches" v-bind:key="branch.id" class="py-1">
                                    <el-link type="info" :underline="false" @click="changeBranch(branch.id)"> {{branch.label}}</el-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <span class="p-1 pr-6"></span>
                    <li v-if="!this.$store.getters.isLoggedIn">
                        <router-link :to="{ path: 'login'}"><i class="el-icon-key p-1 mr-1"></i>Inloggen</router-link>
                    </li>
                </ul>

                <div v-if="this.$store.getters.isLoggedIn">
                    <ul class="pl-4">
                        <li><a href="#" @click="editProfile()"><i class="el-icon-user p-1 mr-1"></i>Profiel</a></li>
                        <span class="p-1"></span>
                        <li v-if="this.$store.getters.isStaff"><a href="#" @click="showPerformancesDialog()"><i class="el-icon-timer p-1 mr-1"></i>Prestaties</a></li>
                        <span class="p-1"></span>
                        <li><a href="#" @click="logout"><i class="el-icon-switch-button p-1 mr-1"></i>Uitloggen</a></li>
                        <span class="p-1"></span>
                    </ul>
                </div>
            </div>
        </el-drawer>
      </div>
    </header>
</template>

<script>
    import PerformancesOverviewDialog from "../../dashboard/prestations/dialogs/PerformancesOverviewDialog";
    import EnrollmentAdminDialog from "../../dashboard/enrollments/dialogs/EnrollmentAdminDialog";
    import moment from 'moment'

    export default {
        name: "OrcaHeader",
        components: {
            PerformancesOverviewDialog,
            EnrollmentAdminDialog
        },
        props: ['branchId', 'branchOptions'],
        data() {
           return {
               drawer: false,
               showDisciplines: false
           }
        },
        methods: {
            editProfile() {
                this.$http.get('users/profile').then((response) => {
                    this.$refs.profileDialog.edit(response.data.enrollment)
                }).catch(function (error) {
                    console.log(error)
                })
            },
            showPerformancesDialog() {
                const user = {firstName: this.$store.getters.getFirstName, lastName: this.$store.getters.getLastName}
                this.$refs.viewDialog.show(user, this.getMonth.firstDay, this.getMonth.lastDay);
            },
            objEdited(obj) {
                // Add API call here
                this.$http.put(`users/profile`, obj).then((response) => {
                    this.$message({
                        showClose: true,
                        message: "Profiel updates geregisteerd.",
                        type: "success"
                    });
                    this.$refs.profileDialog.close();
                }).catch((error) => {
                    this.$message({
                        showClose: true,
                        message: "Kon profiel niet wijzigen, probeer later opnieuw.",
                        type: "error"
                    });
                    console.log(error);
                })
            },
            logout () {
                this.$store.dispatch('logout')
            },
            isPseudoBranch: function (id) {
                if(this.branchOptions) {
                    const branch = this.branchOptions.find(function(branch) {
                        return branch.id === id;
                    });

                    return branch !== undefined ? branch.pseudo : false;
                }
            },
            getCurrentBranchName: function (id) {
                if(this.branchOptions) {
                    const branch = this.branchOptions.find(function(branch) {
                        return branch.id === id;
                    });

                    return branch !== undefined && !branch.pseudo ? branch.label: 'Disciplines'
                }
            },
            changeBranch(branchId) {
                this.$parent.changeBranch(branchId)
            },
            enroll() {
                this.$parent.addEnrollment()
            },
            showDisc() {
                this.showDisciplines = !this.showDisciplines;
            }
        },
        computed: {
            getMonth() {
                const y = moment().toDate().getFullYear()
                const m = moment().toDate().getMonth()
                let firstDay = new Date(y, m, 1);
                let lastDay = new Date(y, m + 1, 0);

                firstDay = moment(firstDay).format("D-MM-YYYY")
                lastDay = moment(lastDay).format("D-MM-YYYY")

                return {
                    firstDay: firstDay,
                    lastDay: lastDay
                };
            },
            nonPseudoBranches() {
                if (this.branchOptions) {
                    return this.branchOptions.filter(e => {
                        return !e.pseudo
                    })
                } else {
                    return []
                }
            }
        }
    }
</script>

<style scoped>
    .mob-menu {
        display: none;
    }
    @media only screen and (max-width: 800px) {
        .nav-main, .status-button {
            display: none;
        }
        .mob-menu {
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/header/OrcaHeader.vue